import React from "react";

export const Error = ({error}) => {
    console.error(error)

    return <div>Erreur </div>
}
